// extracted by mini-css-extract-plugin
module.exports = {"header":"header___2YYPF","content":"content___2fn8R"};